export const categories = [
  {
    id: 'cognitive-science',
    name: '认知科学',
    slug: 'cognitive-science',
    description: '探索人类认知的奥秘，从神经科学到心理学，揭开思维与意识的本质。',
    icon: 'ri-brain-line',
    articleCount: 42,
  },
  {
    id: 'learning-methods',
    name: '学习方法',
    slug: 'learning-methods',
    description: '掌握高效学习的科学方法，提升记忆、理解与知识迁移能力。',
    icon: 'ri-book-open-line',
    articleCount: 56,
  },
  {
    id: 'personal-growth',
    name: '自我成长',
    slug: 'personal-growth',
    description: '发掘内在潜力，构建系统性成长框架，实现个人能力的持续进化。',
    icon: 'ri-seedling-line',
    articleCount: 38,
  },
  {
    id: 'critical-thinking',
    name: '批判性思维',
    slug: 'critical-thinking',
    description: '培养独立思考能力，学会理性分析和逻辑推理，抵御认知偏见。',
    icon: 'ri-lightbulb-line',
    articleCount: 31,
  },
  {
    id: 'philosophy',
    name: '哲学思辨',
    slug: 'philosophy',
    description: '深入东西方哲学传统，思考存在、价值与意义等根本问题。',
    icon: 'ri-scales-3-line',
    articleCount: 27,
  },
  {
    id: 'productivity',
    name: '效率提升',
    slug: 'productivity',
    description: '优化工作流程，掌握时间管理艺术，实现高效产出与生活平衡。',
    icon: 'ri-timer-line',
    articleCount: 45,
  },
];

export const articles = [
  {
    id: 'art-001',
    title: '深度工作：如何在碎片化时代重建专注力',
    slug: 'deep-work-rebuild-focus',
    category: 'productivity',
    categoryName: '效率提升',
    author: '林教授',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20scholar%20portrait%20with%20warm%20smile%2C%20simple%20studio%20background%2C%20soft%20lighting%2C%20editorial%20photography&width=100&height=100&seq=avatar-lin&orientation=squarish',
    date: '2026-07-15',
    readTime: '12分钟',
    excerpt: '在信息爆炸的时代，深度工作能力已成为最稀缺的认知资源。本文从神经科学角度出发，探讨如何通过刻意训练重建深度专注力，实现认知效率的质的飞跃。',
    image: 'https://readdy.ai/api/search-image?query=Calm%20minimalist%20workspace%20with%20warm%20wooden%20desk%20and%20soft%20natural%20light%2C%20open%20notebook%20and%20pen%2C%20plant%20on%20desk%2C%20scholarly%20atmosphere%2C%20clean%20aesthetic%2C%20editorial%20photography%20with%20soft%20shadows&width=800&height=500&seq=art-001&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '为什么深度工作如此重要？',
      },
      {
        type: 'paragraph',
        text: '在当今数字化时代，我们的注意力被无数信息碎片切割。社交媒体推送、即时通讯消息、邮件提醒——这些看似微小的干扰，实际上在持续消耗我们最珍贵的认知资源。研究表明，一次被打断后，大脑平均需要23分钟才能重新回到原来的专注状态。',
      },
      {
        type: 'paragraph',
        text: '深度工作（Deep Work）是卡尔·纽波特教授提出的概念，指的是在无干扰状态下进行的、能将认知能力推向极限的专业活动。这种工作模式能创造出新的价值，提升技能水平，而且难以被复制。',
      },
      {
        type: 'heading',
        text: '专注力的神经科学基础',
      },
      {
        type: 'paragraph',
        text: '从神经科学角度来看，专注力与前额叶皮层的执行功能密切相关。当我们进行深度工作时，大脑的默认模式网络（Default Mode Network）被抑制，而执行控制网络（Executive Control Network）被激活。这种状态的切换需要消耗大量能量，频繁切换会导致认知疲劳。',
      },
      {
        type: 'paragraph',
        text: '更重要的是，深度工作能促进髓鞘的形成——这是一种包裹在神经元轴突外的绝缘物质，能加速神经信号的传导速度。简单来说，深度工作让大脑变得更高效。',
      },
      {
        type: 'heading',
        text: '重建专注力的四个实践方法',
      },
      {
        type: 'paragraph',
        text: '第一，设定明确的深度工作时间段。每天固定2-3小时，关闭所有通知，创造一个不受打扰的环境。这不仅能提高产出质量，还能训练大脑进入深度工作状态的能力。',
      },
      {
        type: 'paragraph',
        text: '第二，采用"单任务"工作法。摒弃多任务处理的迷思，一次只专注于一件事。每完成一个任务后，给自己短暂的休息时间，让大脑恢复。',
      },
      {
        type: 'paragraph',
        text: '第三，建立深度工作的仪式感。固定的工作场所、特定的背景音乐、一杯茶或咖啡——这些仪式化的行为能触发大脑的条件反射，更快进入专注状态。',
      },
      {
        type: 'paragraph',
        text: '第四，定期进行"数字排毒"。每周安排半天或一天时间，完全远离电子设备，让大脑从持续的信息轰炸中得到真正的休息和恢复。',
      },
      {
        type: 'heading',
        text: '结语',
      },
      {
        type: 'paragraph',
        text: '深度工作不是一种技巧，而是一种生活方式的选择。在这个注意力经济时代，能够深度工作的人将拥有不可替代的竞争优势。从今天开始，为自己创造一个可以深度思考的空间，你会发现一个全新的认知世界。',
      },
    ],
    tags: ['专注力', '深度工作', '认知科学', '效率提升'],
  },
  {
    id: 'art-002',
    title: '认知偏见手册：识别并克服常见的思维陷阱',
    slug: 'cognitive-bias-handbook',
    category: 'critical-thinking',
    categoryName: '批判性思维',
    author: '王博士',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20scientist%20portrait%20with%20confident%20expression%2C%20simple%20light%20background%2C%20soft%20studio%20lighting%2C%20editorial%20photography&width=100&height=100&seq=avatar-wang&orientation=squarish',
    date: '2026-07-10',
    readTime: '15分钟',
    excerpt: '认知偏见是人类思维中普遍存在的系统性偏差。本文系统梳理了十余种常见的认知偏见，结合心理学研究成果，提供实用策略帮助你识别和克服这些思维陷阱。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20brain%20illustration%20with%20warm%20tones%2C%20light%20and%20shadow%20contrast%2C%20clean%20minimalist%20style%2C%20conceptual%20design%2C%20soft%20beige%20background&width=800&height=500&seq=art-002&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '什么是认知偏见？',
      },
      {
        type: 'paragraph',
        text: '认知偏见（Cognitive Bias）是指人们在处理和解释信息时，系统性地偏离理性判断的倾向。这些偏见并非偶然错误，而是人类思维机制的固有特征——它们通常源于大脑为节省认知资源而采取的"捷径"策略。',
      },
      {
        type: 'heading',
        text: '确认偏见：我们只看到想看到的东西',
      },
      {
        type: 'paragraph',
        text: '确认偏见是最为普遍的认知偏见之一。它表现为人们倾向于搜索、解释和记忆那些能够证实自己已有信念的信息，同时忽视或贬低与之矛盾的证据。无论是政治立场、投资决策还是日常判断，确认偏见都在潜移默化地影响我们。',
      },
      {
        type: 'paragraph',
        text: '克服方法：主动寻找与自己观点相反的证据，养成"反过来想"的习惯。在做重要决策前，问自己："如果我的判断是错误的，可能的原因是什么？"',
      },
      {
        type: 'heading',
        text: '可得性启发：容易被想起的就被认为是重要的',
      },
      {
        type: 'paragraph',
        text: '可得性启发是指人们倾向于根据信息在记忆中提取的容易程度来判断事件发生的概率或重要性。例如，在新闻中频繁看到飞机失事的报道，人们会高估空难的风险，而低估更常见的交通事故风险。',
      },
      {
        type: 'paragraph',
        text: '克服方法：在做判断时，尽量依赖统计数据而非个人记忆。养成查阅数据和事实的习惯，用客观信息替代主观印象。',
      },
    ],
    tags: ['认知偏见', '批判性思维', '心理学', '决策科学'],
  },
  {
    id: 'art-003',
    title: '费曼学习法：用最简单的语言掌握最复杂的概念',
    slug: 'feynman-technique-mastery',
    category: 'learning-methods',
    categoryName: '学习方法',
    author: '陈导师',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20educator%20portrait%20with%20kind%20smile%2C%20warm%20studio%20lighting%2C%20simple%20background%2C%20editorial%20photography&width=100&height=100&seq=avatar-chen&orientation=squarish',
    date: '2026-07-08',
    readTime: '10分钟',
    excerpt: '费曼学习法被誉为"终极学习法"。通过教会别人来学会知识，这种以教代学的方法能帮你真正理解任何复杂概念。本文详细拆解费曼学习法的四个步骤。',
    image: 'https://readdy.ai/api/search-image?query=Clean%20white%20chalkboard%20with%20elegant%20handwritten%20diagrams%20and%20notes%2C%20warm%20natural%20light%2C%20scholarly%20atmosphere%2C%20minimalist%20style%2C%20editorial%20photography&width=800&height=500&seq=art-003&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '费曼学习法的核心思想',
      },
      {
        type: 'paragraph',
        text: '诺贝尔物理学奖得主理查德·费曼以其能将复杂概念解释得极其简单而闻名。费曼学习法的核心思想是：如果你不能简单地解释一个概念，那就说明你还没有真正理解它。',
      },
      {
        type: 'heading',
        text: '第一步：选择你要学习的概念',
      },
      {
        type: 'paragraph',
        text: '在白纸最上方写下你要学习的概念名称。这个步骤看似简单，却是整个学习方法的基础——它让你明确学习目标，集中全部注意力在一个主题上。',
      },
      {
        type: 'heading',
        text: '第二步：用最简单的语言解释它',
      },
      {
        type: 'paragraph',
        text: '假设你在向一个完全不懂这个领域的人解释这个概念。使用最简单的词汇，避免任何专业术语。如果在某个地方卡住了或者不得不使用复杂的术语，那就说明你在这个点上理解不够深入。',
      },
      {
        type: 'heading',
        text: '第三步：回到原始材料，填补知识空白',
      },
      {
        type: 'paragraph',
        text: '当你发现解释不清楚的地方，回到教材、论文或原始资料中重新学习这些部分。直到你能用简单的语言流利地解释为止。这个过程是费曼学习法中最有价值的部分——它精确地指出了你的知识盲区。',
      },
      {
        type: 'heading',
        text: '第四步：简化和类比',
      },
      {
        type: 'paragraph',
        text: '最后，尝试用一个生动的类比或比喻来总结这个概念。好的类比能将新知识与已有的认知结构连接起来，大幅提高理解和记忆的效果。',
      },
    ],
    tags: ['费曼学习法', '学习方法', '知识内化', '教育'],
  },
  {
    id: 'art-004',
    title: '习惯养成的神经可塑性原理',
    slug: 'habit-formation-neuroplasticity',
    category: 'cognitive-science',
    categoryName: '认知科学',
    author: '张研究员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20researcher%20portrait%2C%20warm%20and%20approachable%2C%20simple%20studio%20lighting%2C%20clean%20background%2C%20editorial%20photography&width=100&height=100&seq=avatar-zhang&orientation=squarish',
    date: '2026-07-05',
    readTime: '14分钟',
    excerpt: '为什么改变习惯如此困难？答案藏在神经可塑性中。本文从脑科学角度解析习惯形成的神经机制，并提供基于科学的习惯养成与改变策略。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20artistic%20neural%20pathways%20visualization%2C%20warm%20golden%20and%20green%20tones%2C%20minimalist%20style%2C%20conceptual%20science%20art%2C%20soft%20lighting&width=800&height=500&seq=art-004&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '习惯的神经基础',
      },
      {
        type: 'paragraph',
        text: '在大脑中，习惯的形成与基底节（特别是纹状体）密切相关。当一个行为被反复执行时，神经元之间的连接会逐渐加强，形成高效的神经通路。这就是神经可塑性的核心机制——"一起激活的神经元，会连接在一起"。',
      },
    ],
    tags: ['神经可塑性', '习惯养成', '脑科学', '行为改变'],
  },
  {
    id: 'art-005',
    title: '苏格拉底式提问：批判性思维的核心工具',
    slug: 'socratic-questioning-tool',
    category: 'critical-thinking',
    categoryName: '批判性思维',
    author: '李哲学',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20philosophy%20professor%20portrait%2C%20thoughtful%20expression%2C%20warm%20studio%20lighting%2C%20clean%20background%2C%20editorial%20photography&width=100&height=100&seq=avatar-li&orientation=squarish',
    date: '2026-06-28',
    readTime: '11分钟',
    excerpt: '苏格拉底式提问不仅仅是问问题，而是一门引导思考的艺术。本文介绍六种苏格拉底式提问类型，帮助你在日常对话和思考中应用这一强大工具。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Greek%20style%20marble%20architectural%20detail%20with%20warm%20golden%20light%2C%20abstract%20artistic%20rendering%2C%20minimalist%20composition%2C%20soft%20beige%20tones&width=800&height=500&seq=art-005&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '苏格拉底式提问的本质',
      },
      {
        type: 'paragraph',
        text: '苏格拉底式提问是一种系统的、深入的提问方式，旨在探索复杂思想、揭示假设、分析概念，并区分已知与未知。它不仅仅是提问，更是一种探究真理的严谨方法。',
      },
    ],
    tags: ['苏格拉底', '批判性思维', '提问技巧', '哲学'],
  },
  {
    id: 'art-006',
    title: '正念冥想对认知功能的科学验证',
    slug: 'mindfulness-cognitive-benefits',
    category: 'cognitive-science',
    categoryName: '认知科学',
    author: '张研究员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20scientist%20portrait%20with%20warm%20smile%2C%20simple%20studio%20background%2C%20soft%20lighting%2C%20editorial%20photography&width=100&height=100&seq=avatar-zhang2&orientation=squarish',
    date: '2026-06-20',
    readTime: '13分钟',
    excerpt: '正念冥想从传统修行方式走进科学实验室，大量研究发现其对注意力、情绪调节和认知灵活性有显著改善。本文综述最新神经科学研究结果。',
    image: 'https://readdy.ai/api/search-image?query=Serene%20minimalist%20meditation%20space%20with%20warm%20natural%20light%20streaming%20through%20window%2C%20simple%20cushion%20on%20wooden%20floor%2C%20peaceful%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=art-006&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '正念的科学定义',
      },
      {
        type: 'paragraph',
        text: '在科学研究中，正念被定义为"对当下经验的非评判性觉察"。这一定义由乔恩·卡巴金提出，使正念从宗教语境中抽离出来，成为可被科学研究的心理现象。',
      },
    ],
    tags: ['正念', '冥想', '认知科学', '脑科学'],
  },
  {
    id: 'art-007',
    title: '金字塔原理：结构化思考与表达的艺术',
    slug: 'pyramid-principle-thinking',
    category: 'learning-methods',
    categoryName: '学习方法',
    author: '陈导师',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20business%20educator%20portrait%2C%20confident%20and%20approachable%2C%20clean%20studio%20lighting%2C%20editorial%20photography&width=100&height=100&seq=avatar-chen2&orientation=squarish',
    date: '2026-06-15',
    readTime: '9分钟',
    excerpt: '金字塔原理是麦肯锡咨询公司经典的结构化思维方法。学会金字塔原理，你的思考会更清晰，表达会更有说服力。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20geometric%20pyramid%20structure%20on%20warm%20paper%20texture%20background%2C%20clean%20architectural%20design%2C%20soft%20beige%20tones%2C%20editorial%20style&width=800&height=500&seq=art-007&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '金字塔原理的基本结构',
      },
      {
        type: 'paragraph',
        text: '金字塔原理的核心是"结论先行"。在任何表达中，先给出中心思想或核心结论，然后用分论点支撑，每个分论点再用具体事实和数据支撑。这种结构符合人脑的认知规律。',
      },
    ],
    tags: ['金字塔原理', '结构思维', '逻辑表达', '沟通'],
  },
  {
    id: 'art-008',
    title: '斯多葛哲学与现代心理韧性',
    slug: 'stoicism-mental-resilience',
    category: 'philosophy',
    categoryName: '哲学思辨',
    author: '李哲学',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20philosopher%20portrait%2C%20wise%20and%20calm%20expression%2C%20simple%20studio%20lighting%2C%20editorial%20photography&width=100&height=100&seq=avatar-li2&orientation=squarish',
    date: '2026-06-10',
    readTime: '16分钟',
    excerpt: '斯多葛哲学的核心教义——控制可控的，接受不可控的——在当代心理学中得到了充分验证。本文探讨斯多葛智慧如何帮助我们建立心理韧性。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Roman%20style%20marble%20column%20with%20warm%20morning%20light%2C%20abstract%20artistic%20composition%2C%20minimalist%20aesthetic%2C%20soft%20beige%20and%20golden%20tones&width=800&height=500&seq=art-008&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '控制二分法',
      },
      {
        type: 'paragraph',
        text: '斯多葛哲学最重要的洞见之一是"控制二分法"：有些事情在我们的控制之内，有些则不在。我们的判断、欲望和行动在控制之内；他人的看法、外部事件和结果则不在。智慧在于将精力集中在可控之事上。',
      },
    ],
    tags: ['斯多葛', '哲学', '心理韧性', '情绪管理'],
  },
  {
    id: 'art-009',
    title: '番茄工作法的科学原理与优化实践',
    slug: 'pomodoro-technique-science',
    category: 'productivity',
    categoryName: '效率提升',
    author: '林教授',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20productivity%20expert%20portrait%2C%20energetic%20and%20friendly%2C%20clean%20studio%20lighting%2C%20editorial%20photography&width=100&height=100&seq=avatar-lin2&orientation=squarish',
    date: '2026-06-05',
    readTime: '8分钟',
    excerpt: '番茄工作法可能是最简单却最高效的时间管理方法。本文从认知心理学角度解读番茄工作法背后的科学原理，并提供个性化的优化建议。',
    image: 'https://readdy.ai/api/search-image?query=Minimalist%20desk%20with%20timer%20and%20notebook%2C%20warm%20natural%20light%2C%20clean%20workspace%20aesthetic%2C%20soft%20beige%20tones%2C%20editorial%20photography&width=800&height=500&seq=art-009&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '番茄工作法的起源',
      },
      {
        type: 'paragraph',
        text: '番茄工作法由弗朗西斯科·西里洛在1980年代创立。他发现使用厨房定时器（番茄形状）设定25分钟专注工作、5分钟休息的节奏，能显著提高效率。',
      },
    ],
    tags: ['番茄工作法', '时间管理', '效率', '专注'],
  },
  {
    id: 'art-010',
    title: '成长型思维：改变你对自己潜能的信念',
    slug: 'growth-mindset-potential',
    category: 'personal-growth',
    categoryName: '自我成长',
    author: '王博士',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20psychologist%20portrait%2C%20warm%20and%20inspiring%20expression%2C%20clean%20studio%20lighting%2C%20editorial%20photography&width=100&height=100&seq=avatar-wang2&orientation=squarish',
    date: '2026-05-28',
    readTime: '10分钟',
    excerpt: '卡罗尔·德韦克的成长型思维理论改变了教育学和心理学对"能力"的认知。本文深入解读成长型思维的核心概念，以及如何在日常生活中培养它。',
    image: 'https://readdy.ai/api/search-image?query=Young%20plant%20seedling%20growing%20from%20open%20book%2C%20warm%20sunlight%2C%20symbolic%20growth%20concept%2C%20minimalist%20composition%2C%20editorial%20photography&width=800&height=500&seq=art-010&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '固定型思维 vs 成长型思维',
      },
      {
        type: 'paragraph',
        text: '固定型思维认为能力是天生的、固定的；成长型思维则认为能力可以通过努力和学习不断发展。这两种信念会深刻影响一个人面对挑战、挫折和批评时的反应。',
      },
    ],
    tags: ['成长型思维', '自我成长', '心理学', '教育'],
  },
  {
    id: 'art-011',
    title: '间隔重复：让记忆效率翻倍的科学方法',
    slug: 'spaced-repetition-memory',
    category: 'learning-methods',
    categoryName: '学习方法',
    author: '陈导师',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20education%20researcher%20portrait%2C%20thoughtful%20expression%2C%20clean%20studio%20lighting%2C%20editorial%20photography&width=100&height=100&seq=avatar-chen3&orientation=squarish',
    date: '2026-05-20',
    readTime: '11分钟',
    excerpt: '艾宾浩斯遗忘曲线告诉我们，遗忘是人类记忆的自然规律。但间隔重复法能有效对抗遗忘，将短期记忆转化为长期记忆。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20abstract%20flowing%20lines%20representing%20time%20and%20memory%2C%20warm%20minimalist%20style%2C%20soft%20beige%20background%2C%20conceptual%20design&width=800&height=500&seq=art-011&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '遗忘的科学',
      },
      {
        type: 'paragraph',
        text: '艾宾浩斯遗忘曲线显示，新学到的信息在最初的20分钟内会遗忘约42%，一天后遗忘约67%。但如果在遗忘发生前进行有策略的复习，记忆的巩固效果会大幅提升。',
      },
    ],
    tags: ['间隔重复', '记忆', '学习方法', '认知科学'],
  },
  {
    id: 'art-012',
    title: '设计你的人生：斯坦福人生设计课精华',
    slug: 'designing-your-life',
    category: 'personal-growth',
    categoryName: '自我成长',
    author: '王博士',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20life%20coach%20portrait%2C%20warm%20and%20optimistic%2C%20clean%20studio%20lighting%2C%20editorial%20photography&width=100&height=100&seq=avatar-wang3&orientation=squarish',
    date: '2026-05-15',
    readTime: '14分钟',
    excerpt: '比尔·博内特和戴夫·伊万斯将设计思维应用于人生规划，开创了"人生设计"这一全新领域。本文提炼课程精华，帮你重新思考人生的可能性。',
    image: 'https://readdy.ai/api/search-image?query=Open%20blank%20sketchbook%20with%20design%20tools%20on%20warm%20wooden%20desk%2C%20creative%20workspace%2C%20natural%20light%2C%20minimalist%20aesthetic%2C%20editorial%20photography&width=800&height=500&seq=art-012&orientation=landscape',
    content: [
      {
        type: 'heading',
        text: '人生设计思维',
      },
      {
        type: 'paragraph',
        text: '传统职业规划假设存在一个"正确"的人生路径等待被发现。而人生设计思维认为，人生是可以被设计的，你可以拥有多个可行的"奥德赛计划"，通过原型测试找到最适合自己的方向。',
      },
    ],
    tags: ['人生设计', '自我成长', '职业规划', '斯坦福'],
  },
];